/* Presentation only. MakeCommerce owns rates, locker persistence and checkout validation. */
if (!customElements.get('atiems-delivery-status')) {
  customElements.define('atiems-delivery-status', class extends HTMLElement {
    connectedCallback() {
      this.place = this.querySelector('#mk-shipping-solution-place');
      this.loading = this.querySelector('[data-delivery-loading]');
      this.fallback = this.querySelector('[data-delivery-fallback]');
      if (!this.place) return;
      this.ready = false;
      this.expired = false;
      this.onReload = () => window.location.reload();
      this.querySelector('[data-delivery-reload]')?.addEventListener('click', this.onReload);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.place, { childList: true, subtree: true, attributes: true,
        attributeFilter: ['hidden', 'style', 'class', 'disabled'] });
      this.timeout = window.setTimeout(() => { this.expired = true; this.update(); }, 15000);
      this.update();
    }
    update() {
      // MakeCommerce renders its carrier choices as plain tiles (not form controls),
      // so any visible rendered content inside the placement hook counts as loaded.
      if (!this.ready) {
        this.ready = [...this.place.querySelectorAll('*')]
          .some(el => !el.closest('[hidden]') && el.getClientRects().length > 0 && (el.textContent.trim() || el.matches('img, svg, input, select, button')));
      }
      if (this.ready) {
        clearTimeout(this.timeout);
        this.observer?.disconnect();
      }
      if (this.loading) this.loading.hidden = this.ready || this.expired;
      if (this.fallback) this.fallback.hidden = this.ready || !this.expired;
    }
    disconnectedCallback() {
      clearTimeout(this.timeout);
      this.observer?.disconnect();
      this.querySelector('[data-delivery-reload]')?.removeEventListener('click', this.onReload);
    }
  });
}
